<template>
<section class="charts-wrapper">
  <section class="normal-wrapper">
    <e-chart ref="normal-chart" />
  </section>

  <section class="related-wrapper">
    <div class="related-header">{{data.name}} 相关性分析</div>
    <div class="related-selector">
      <el-select
        v-model="xFactorId"
        size="small"
        style="width:120px;"
        @change="onRelatedFactorIdChanged"
      >
        <el-option
          v-for="factorId in relatedFactorIds"
          :key="factorId"
          :value="factorId"
          :label="factorMap[factorId].name"
        />
      </el-select>

      <span style="padding:.5em;">VS</span>

      <el-select
        v-model="yFactorId"
        size="small"
        style="width:120px;"
        @change="onRelatedFactorIdChanged"
      >
        <el-option
          v-for="factorId in relatedFactorIds"
          :key="factorId"
          :value="factorId"
          :label="factorMap[factorId].name"
        />
      </el-select>
    </div>

    <related-chart
      :base-data="relatedData.x"
      :related-data="relatedData.y"
    />
  </section>
</section>
</template>

<script>
import EChart from '../../../../components/Charts/ECharts'
import {AXIS_LABEL, AXIS_LINE_STYLE, TEXT_FONT_FAMILY} from '../../../../components/Data/FactorCharts/chartStyle'
import RelatedChart from '../../../../components/Data/RelatedChart'
import BaseStore from '../../../../components/BaseStore'
export default {
  name: 'Charts',
  components: {RelatedChart, EChart},
  extends: BaseStore,
  props: {
    query: {
      required: true,
      type: Object
    },
    data: {
      required: true,
      type: Object
    },
    concType: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      xFactorId: '1006',
      yFactorId: '1003',
      relatedData: Object.freeze({
        x: {
          data: []
        },
        y: {
          data: []
        }
      })
    }
  },
  computed: {
    pmFactorIds: () => ['1007', '1008'],
    otherFactorIds: () => ['1001', '1002', '1003', '1004', '1005', '1006'],
    relatedFactorIds () {
      return this.query.factorIds
    },
    formatData () {
      let {concType} = this
      let data = JSON.parse(JSON.stringify(this.data))

      if (concType === 2) {
        let {pmFactorIds} = this

        data.data.forEach(data => {
          let sum = pmFactorIds.reduce((sum, factorId) => {
            let value = data[factorId]

            if (Number.isFinite(value)) {
              sum += value
            }

            return sum
          }, 0)

          pmFactorIds.forEach(factorId => {
            data[factorId] = Number((data[factorId] / sum * 100).toFixed(2))
          })
        })
      }

      return data
    },
    pmUnit () {
      return this.concType === 2 ? '%' : this.factorMap['1007'].displayUnit
    }
  },
  methods: {
    render () {
      this.renderNormalChart()
      this.renderRelatedChart(this.data.data)
    },
    concTypeChange () {
      this.renderNormalChart()
    },
    renderNormalChart () {
      let {formatData, otherFactorIds, factorMap} = this
      let dataList = formatData.data
      let dataTimes = dataList.map(data => data.dataTime)
      let dataTimesLen = dataTimes.length
      let dataZoomStart = dataTimesLen <= 72 ? 0 : Number(((dataTimesLen - 72) / dataTimesLen * 100).toFixed(0))
      let yAxis = [...new Set(otherFactorIds.map(factorId => factorMap[factorId].displayUnit))].map((unit, index) => ({
        type: 'value',
        name: unit,
        nameLocation: 'center',
        nameGap: 30,
        axisLine: {
          // show: false
          lineStyle: AXIS_LINE_STYLE
        },
        axisLabel: {
          ...AXIS_LABEL,
          fontFamily: TEXT_FONT_FAMILY
        },
        splitLine: {
          show: index === 0
        },
        gridIndex: 0
      }))
      let unitMap = yAxis.reduce((map, {name}, index) => {
        map[name] = index
        return map
      }, {})
      let series = otherFactorIds.map(factorId => {
        let factor = factorMap[factorId]

        return {
          name: factor.name,
          type: 'line',
          xAxisIndex: 0,
          yAxisIndex: unitMap[factor.displayUnit],
          showSymbol: false,
          data: dataList.map(data => data[factorId])
        }
      }).concat(this.pmFactorIds.map(factorId => ({
        name: factorMap[factorId].name,
        type: 'bar',
        stack: 'PM',
        barMaxWidth: 30,
        xAxisIndex: 1,
        yAxisIndex: yAxis.length,
        data: dataList.map(data => data[factorId])
      })))

      yAxis.push({
        type: 'value',
        name: this.pmUnit,
        nameLocation: 'center',
        nameGap: 30,
        axisLine: {
          // show: false
          lineStyle: AXIS_LINE_STYLE
        },
        axisLabel: {
          ...AXIS_LABEL,
          fontFamily: TEXT_FONT_FAMILY
        },
        splitLine: {
          show: true
        },
        gridIndex: 1
      })
      let chartOpt = {
        title: {
          text: `${formatData.name} 常规因子`,
          left: 'center',
          textStyle: {
            fontFamily: TEXT_FONT_FAMILY
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        axisPointer: {
          link: {xAxisIndex: 'all'}
        },
        grid: [{
          top: 40,
          right: 45,
          bottom: 260,
          left: 30,
          containLabel: true
        }, {
          top: 260,
          right: 45,
          bottom: 45,
          left: 30,
          containLabel: true
        }],
        xAxis: [{
          type: 'category',
          data: dataTimes,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            show: false,
            fontFamily: TEXT_FONT_FAMILY,
            formatter: date => new Date(date).format('MM月DD日HH时')
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          gridIndex: 0
        }, {
          type: 'category',
          data: dataTimes,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: TEXT_FONT_FAMILY,
            formatter: date => new Date(date).format('MM月DD日HH时')
          },
          axisTick: {
            show: true,
            alignWithLabel: true
          },
          gridIndex: 1
        }],
        yAxis,
        series,
        dataZoom: [{
          type: 'inside',
          start: dataZoomStart,
          end: 100,
          realtime: true,
          xAxisIndex: [0, 1],
          minSpan: 5
        }, {
          type: 'slider',
          start: dataZoomStart,
          end: 0,
          xAxisIndex: [0, 1],
          realtime: true,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }]
      }

      this.$refs['normal-chart'].setOpt(chartOpt)
    },
    renderRelatedChart (dataList) {
      let {factorMap, xFactorId, yFactorId} = this

      this.relatedData = Object.freeze({
        x: this.getFactor(factorMap, xFactorId, dataList),
        y: this.getFactor(factorMap, yFactorId, dataList)
      })
    },
    formatRelatedData (dataList) {
      let dataMap = dataList.reduce((map, data) => {
        let dataTime = data.dataTime
        let valueData = map[dataTime]

        if (!valueData) {
          valueData = map[dataTime] = {dataTime}
        }

        valueData[data.factorId] = data.value

        return map
      }, {})

      this.renderRelatedChart(Object.values(dataMap))
    },
    getFactor (factorMap, factorId, dataList) {
      let factor = JSON.parse(JSON.stringify(factorMap[factorId]))
      factor.unit = factor.displayUnit

      factor.data = dataList.map(data => ({
        dataTime: data.dataTime,
        value: data[factorId]
      }))

      return factor
    },
    onRelatedFactorIdChanged () {
      let query = JSON.parse(JSON.stringify(this.query))
      query.factorIds = [this.xFactorId, this.yFactorId]
      query.siteIds = [this.data.id]
      this.changeLoadStatus(true)
      this.$api.Data.getHistoryData(query).then(this.formatRelatedData).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.charts-wrapper {
  width: 100%;
  height: 500px;
  min-height: 500px;

  &:after {
    content: "";
    clear: both;
  }

  > * {
    float: left;
    height: 100%;
  }

  > .normal-wrapper {
    width: 58%;
  }

  > .related-wrapper {
    $RELATED-HEADER-HEIGHT: 40px;
    position: relative;
    width: 42%;
    padding-top: 100px;

    > .related-header {
      position: absolute;
      font-size: 22px;
      top: 0;
      left: 0;
      width: 100%;
      line-height: $RELATED-HEADER-HEIGHT;
      text-align: center;
    }

    > .related-selector {
      position: absolute;
      top: $RELATED-HEADER-HEIGHT;
      left: 0;
      width: 100%;
      height: 60px;
      padding: 14px 0;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/08Related/Charts.vue